import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { Box } from "@mui/material";
import { postApi } from "../../hooks/Api";
import dranoop from "../../assets/images/dr_anoop.jpg";

function Hero() {
  const [Images, setImages] = useState([]);

  const getData = async () => {
    const response = await postApi("courasel/get");
    setImages(response?.data?.data);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <section id="hero" className="pt-20 bg-neutral-900 min-h-[70vh]">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div className="text-white space-y-6 animate__animated animate__fadeInLeft font-poppins">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
              All-in-One Health Solution
            </h1>
            <p className="text-xl md:text-2xl text-gray-300">
              25 Years Of Experience in Medical Services
            </p>
            <div className="space-y-4">
              <p className="text-gray-300">
                Dr. Anoop Choudhary is a distinguished homeopathy practitioner
                based in Bhopal, known for his expertise in holistic healthcare.
              </p>
              <div className="flex flex-wrap gap-4">
                <a
                  href="#appointment"
                  className="bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-3 rounded-full transition-colors inline-block"
                >
                  Book Appointment
                </a>
                <a
                  href="#about"
                  className="border border-emerald-500 text-emerald-500 hover:bg-emerald-500 hover:text-white px-8 py-3 rounded-full transition-colors inline-block"
                >
                  Know More
                </a>
              </div>
            </div>
          </div>

          <div className="relative animate__animated animate__fadeInRight">
            <div className="absolute inset-0 bg-emerald-500 rounded-full opacity-10 blur-3xl"></div>
            <img
              src={dranoop}
              alt="Dr Anoop Choudhary"
              className="relative w-full max-w-md mx-auto rounded-3xl shadow-2xl"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 text-white font-poppins">
          <div className="text-center animate__animated animate__fadeInUp">
            <div className="bg-neutral-800 p-6 rounded-xl">
              <img
                src="https://static.vecteezy.com/system/resources/previews/009/731/669/non_2x/hand-and-love-icon-free-vector.jpg"
                alt="Experience"
                className="w-12 h-12 mx-auto mb-4"
              />
              <h3 className="text-lg font-semibold">25+ Years</h3>
              <p className="text-gray-400">Experience</p>
            </div>
          </div>
          <div
            className="text-center animate__animated animate__fadeInUp"
            style={{
              animationDelay: 0.2,
            }}
          >
            <div className="bg-neutral-800 p-6 rounded-xl">
              <img
                src="https://img.freepik.com/free-vector/hand-drawn-little-asian-boy-cartoon-illustration_23-2150445628.jpg"
                alt="Patients"
                className="w-12 h-12 mx-auto mb-4"
              />
              <h3 className="text-lg font-semibold">10,000+</h3>
              <p className="text-gray-400">Patients Treated</p>
            </div>
          </div>
          <div
            className="text-center animate__animated animate__fadeInUp"
            style={{
              animationDelay: 0.4,
            }}
          >
            <div className="bg-neutral-800 p-6 rounded-xl">
              <img
                src="https://t3.ftcdn.net/jpg/04/09/85/00/360_F_409850093_WZjLxcblZJv4ZO2yBmExfD8CRf4LLAji.jpg"
                alt="Specialization"
                className="w-12 h-12 mx-auto mb-4"
              />
              <h3 className="text-lg font-semibold">Multiple</h3>
              <p className="text-gray-400">Specializations</p>
            </div>
          </div>
          <div
            className="text-center animate__animated animate__fadeInUp"
            style={{
              animationDelay: 0.6,
            }}
          >
            <div className="bg-neutral-800 p-6 rounded-xl">
              <img
                src="https://westleedervilleautos.com.au/wp-content/uploads/2019/10/Convenient-Location-300x300.png"
                alt="Location"
                className="w-12 h-12 mx-auto mb-4"
              />
              <h3 className="text-lg font-semibold">Convenient</h3>
              <p className="text-gray-400">Location</p>
            </div>
          </div>
        </div>
      </div>

      {/* Carousel Section */}
      {Images.length > 0 && (
        <Carousel autoPlay interval={3000} infiniteLoop>
          {Images.map((image, index) => (
            <Box key={index}>
              <img
                src={image?.url}
                alt={image?.altText || "carousel image"}
                className="w-full h-[60vh] object-cover"
              />
            </Box>
          ))}
        </Carousel>
      )}
    </section>
  );
}

export default Hero;
